import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {encodingClothsImages} from '../cloths-mockup';
import {encodingSymbolsImages, encodingSymbolsString} from '../symbols-mockup';
import {GeneralDragAndDropComponent} from '../../General/g-drag-and-drop';

@Component({
  selector: 'app-build-message-content',
  templateUrl: './build-message-content.component.html',
  styleUrls: ['./build-message-content.component.css']
})
export class BuildMessageContentComponent extends GeneralDragAndDropComponent implements  OnChanges {

  @Input() level: number;
  @Input() counter: number;
  @Input() isTwoPlayer: boolean;
  @Output() isSolvedChange = new EventEmitter<boolean>();
  @Output() encodedMessageChange = new EventEmitter<number[]>();
  @Output() currentEncodingsChange = new EventEmitter<number[][]>();

  encodings: number[][] = [];
  messageImg: number[] = []; // the message that the user has to encode with the encodings, which are given
  solution: number[] = [];
  clothsImages = encodingClothsImages;
  symbolImages = encodingSymbolsImages;
  solved = false;

  ngOnChanges(changes: SimpleChanges) {
    this.initValues();
  }

  initValues() {
    super.initValues();
    this.encodings = [];
    this.messageImg = [];
    this.solution = [];
    this.solved = false;
    this.setAllDragElementIds();
  }

  checkSolution() {
    if (this.isTwoPlayer) {
      if (this.correctMessage()) {
        this.solved = true;
        this.isSolvedChange.emit(this.solved);
        this.currentEncodingsChange.emit(this.encodings);
        this.encodedMessageChange.emit(this.dropValues);
      } else {
        this.isSolvedChange.emit(this.solved);
      }
    } else {
      this.createSolution();
      if (this.compareArrays(this.solution, this.dropValues)) {
        this.solved = true;
        this.isSolvedChange.emit(this.solved);
        this.currentEncodingsChange.emit(this.encodings);
        this.encodedMessageChange.emit(this.dropValues);
      } else {
        this.isSolvedChange.emit(this.solved);
      }
    }
  }

  createSolution() {
    const result = [];
    for (let i = 0; i < this.messageImg.length; i++) {
      for (let j = 0; j < this.encodings[this.messageImg[i]].length; j++) {
        result.push(this.encodings[this.messageImg[i]][j]);
      }
    }

    this.solution = result;
  }

  correctMessage() {
    for (let i = 0; i < this.dropValues.length / this.encodings[0].length; i++) {
      let founded = true;
      for (let n = 0; n < this.encodings.length; n++) {
        founded = true;
        for (let m = 0; m < this.encodings[n].length; m++) {
          if (this.dropValues[(i * this.encodings[n].length) + m] !== this.encodings[n][m]) {
            founded = false;
          }
        }
        if (founded) {
          break;
        }
      }

      if (!founded) {
        return false;
      }
    }
    return true;
  }

  setEncoding(encoding: number[][]) {
    this.encodings = encoding;
    this.createMessageImg();
  }

  /**
   * Get the indexes of the cloths, which the user has to encode.
   */
  createMessageImg() {
    const length = this.getMessageLength();
    let counter = 0;
    const idx = [];
    while (counter < length) {
      if (this.isTwoPlayer) {
        for (let i = 0; i < this.encodings[0].length; i++) {
          this.dropValues.push(-1);
        }
        counter ++;
      } else {
        const randId = Math.floor((Math.random() * this.encodings.length));
        if (idx.indexOf(randId) === -1) {
          idx.push(randId);
          for (let i = 0; i < this.encodings[0].length; i++) {
            this.dropValues.push(-1);
          }
          counter ++;
        }
      }
    }
    this.messageImg = idx;
  }

  setAllDragElementIds() {
    this.allDragElementIds = encodingSymbolsString;
  }

  getHidden(id: string) {
    if (this.currentDragElementId === null) {
      return true;
    }

    return !(this.currentDragElementId.value === id);
  }

  getActive(i: number) {
    return this.currentBelowElement !== null && parseInt(this.currentBelowElement.id, 10) === i;
  }

  getMessageImgSrc(idx) {
    return this.clothsImages[idx];
  }

  getImageSrc(idx) {
    if (idx === -1) {
      return './assets/images/encoding/empty.png';
    }
    return this.symbolImages[idx];
  }

  getMessageLength() {
    if (this.level === 1) {
      return 1;
    } else if (this.level === 2) {
      return 2;
    } else {
      return 3;
    }
  }

  getNumberOfEncodings() {
    if (this.level === 1) {
      return 3;
    } else if (this.level === 2) {
      return 4;
    } else {
      return 5;
    }
  }

  getDragElementMaxSize() {
    const width = Math.min((100 / (this.getMessageLength() * this.encodings[0].length)), 12);
    return width;
  }

  getMarginLeft() {
    const encodedMessage = this.dropValues.length * this.getDragElementMaxSize();

    return (100 - encodedMessage) / 2;
  }

  /**
   * Compare two arrays arr1 with arr2
   * Return true if both arrays are the same. (same length and same values in the same order)
   * @param arr1
   * @param arr2
   */
  compareArrays(arr1, arr2) {
    if (arr1.length !== arr2.length) {
      return false;
    }

    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i] !== arr2[i]) {
        return false;
      }
    }

    return true;
  }

}
